import React from 'react';
interface MetricCardProps {
  title: string;
  value: string;
  description: string;
  icon?: React.ReactNode;
  percentage?: string;
  timeframe?: string;
}
const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  description,
  icon,
  percentage,
  timeframe
}) => {
  return <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 h-full" data-id="element-101">
      <div className="flex items-start" data-id="element-102">
        {icon && <div className="mr-4 text-primary-600 bg-primary-50 p-2 rounded-md" data-id="element-103">
            {icon}
          </div>}
        <div data-id="element-104">
          <h3 className="text-base font-semibold text-gray-700" data-id="element-105">{title}</h3>
          <div className="flex items-baseline mt-2" data-id="element-106">
            <p className="text-2xl md:text-3xl font-bold text-primary-700" data-id="element-107">
              {value}
            </p>
            {percentage && <span className="ml-2 text-sm font-medium text-green-500" data-id="element-108">
                {percentage}
              </span>}
          </div>
          {timeframe && <p className="text-xs text-gray-500 mt-1" data-id="element-109">{timeframe}</p>}
          <p className="mt-2 text-sm text-gray-600" data-id="element-110">{description}</p>
        </div>
      </div>
    </div>;
};
export default MetricCard;